import React, { Component } from 'react'
import logouticon from "../../assets/images/logout.svg"
import ripple from "../../assets/images/ripple.svg";
import {connect} from "react-redux"
import {logout} from "../../actions/index"


class LogoutButton extends Component {
    render() {
        return (
            <button title="logout" className="logout-btn btn btn-round" onClick={() => this.props.logout()}>
                <img src={this.props.user.logout_fetching ? ripple: logouticon} height="15" alt="" />
            </button>
        )
    }
}

const mapStateToProps = ({loginReducer}) => ({
    user: loginReducer
})

const mapDispatchToProps = {
    logout
}


export default connect(mapStateToProps, mapDispatchToProps)(LogoutButton)